import { render } from "./RefundContent.vue?vue&type=template&id=1dc6286c"
import script from "./RefundContent.vue?vue&type=script&lang=js"
export * from "./RefundContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__